module.exports = __webpack_public_path__ + "static/media/img-porto-1.08ac752d.jpg";